import { TCompanyForm } from "@/features/company/types/company-form";
import { FormField } from "@/modules/irohana-components/elements/FormField";
import { Textarea } from "@/modules/irohana-components/elements/Textarea";
import { Stack } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";

/** その他情報 section: 重要メモ (also surfaced on the Dashboard) and 取引先メモ. */
export const OtherInfoSection: FC = () => {
  const { control } = useFormContext<TCompanyForm>();

  return (
    <Stack gap="16px">
      <FormField<TCompanyForm> name="importantMemo" control={control} fullWidth>
        <Textarea minRows={4} maxRows={8} style={{ width: "100%" }} />
      </FormField>
      <FormField<TCompanyForm> name="companyMemo" control={control} fullWidth>
        <Textarea minRows={4} maxRows={8} style={{ width: "100%" }} />
      </FormField>
    </Stack>
  );
};
